// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { SubmissionError } from 'redux-form'
import { Success } from 'components/Modals'
import updateEntityDetails from './updateEntityDetails'
import { loadingToggler } from 'redux/modules/loading'

import {
  postNewAntennaSpec,
  putNewAntennaSpec,
} from 'helpers/api'

// d is dispatch as provided from redux-form submit handler but we are using a thunk instead.

const submitAntenna = (formValues, d, formProps) => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const { openContextModal } = formProps

      const isNewEntity = getState().databaseDetails.get('isNewEntity')

      try {
        const { entity } = (
          isNewEntity
            ? await postNewAntennaSpec(formValues)
            : await putNewAntennaSpec(formValues)
        )

        const {
          antennaCode,
          antennaSpecId,
        } = entity

        await dispatch(updateEntityDetails(antennaSpecId))

        const modalHeading = `Successfully ${isNewEntity ? 'created new' : 'updated'} antenna`
        const modalMessage = `${antennaCode} was successfully ${isNewEntity ? 'created' : 'updated'}.`

        openContextModal(
          <div className={'padding-half'}>
            <Success
              modalHeading={modalHeading}
              modalMessage={modalMessage} />
          </div>
        )
      } catch (err) {
        console.warn(err)
        throw new SubmissionError({ _error: err.message })
      }
    })
  )
)

export default submitAntenna
